module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAH1JREFUKFNjZCASMBKpjoE8hQ0NDSwcHByLGRkZBb5//x7Y0NDwA2Yj3ESoouWMjIxPGBgYPjAwMJhAFf8BKQYrRFZUXl5eCBJrb2/vYGRkVP7x40dkQ0PDH7DC9vb2DCYmJnWYIph1nZ2dPf/+/btSWVm5gDzP4Asqok0EAGeRKwu+Wk81AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/select_down.png
// module id = 3A20
// module chunks = 0